import {UI} from "../../../stem-core/src/ui/UIBase.js";
import {CloseIcon} from "../../../core/ui/SVGElements.jsx";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme.js";
import {collapseIframe} from "../../widget/misc/WidgetUtils.js";
import {styleRule} from "../../../stem-core/src/decorators/Style.js";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../../blink-sdk/utils/AnalyticsClient.js";
import {StyleSheet} from "../../../stem-core/src/ui/Style.js";


class PanelCloseButtonStyle extends StyleSheet {
    @styleRule
    container = {
        position: "absolute",
        right: 18,
        top: 14,
        cursor: "pointer",
        pointerEvents: "initial",
    };
}

@registerStyle(PanelCloseButtonStyle)
export class PanelCloseButton extends CloseIcon {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            color: this.themeProps.MERCHANT_FRAME_CLOSE_BUTTON_COLOR,
            size: this.themeProps.MERCHANT_FRAME_CLOSE_BUTTON_SIZE,
        };
    }

    onMount() {
        super.onMount();
        this.addClickListener(() => {
            dispatchAnalyticsEvent(AnalyticsEventType.ELEMENT_CLICK);
            collapseIframe();
        });
    }
}
